import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/IssuedResourceReport/IssuedResourceReport.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import Select from 'react-select';
import ReactToPrint from 'react-to-print';

let verificationStatusData = [
    {
        label: 'Verified',
        value: 'verified'
    },
    {
        label: 'Newly found',
        value: 'newly found'
    }
];

class IssuedResourceReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All stock verification data
            issuedResourceListLoading: false,
            totalIssuedResourceListItems: 0,
            issuedResourceList: {},
            pageIndex: 1,
            limit: "10",

            // report filter
            searchByStockVerification: '',

            stockVerificationList: {},
            stockVerificationLoading: false,

            scannedByList: {},
            loadingScannedBy: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Issued To", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: "Accession Number", isVisible: true },
                { name: "Role", isVisible: true },
                { name: "User ID", isVisible: true },
                { name: "Default Academic Year", isVisible: true },
                { name: "Default Department", isVisible: true },
                { name: "Default Group", isVisible: true },
                { name: "Roll Number", isVisible: true },

                { name: "Issued Policy Name", isVisible: true },
                { name: "Location", isVisible: true },

                { name: "Issued Date", isVisible: true },
                { name: "Due Date", isVisible: true },
                { name: "Renewal Date", isVisible: true },
                { name: "Applicable Fine", isVisible: true },
                { name: "Collected Fine", isVisible: true },
                { name: "Issued by", isVisible: true },
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Issued To", key: 'issuedTo' },
                { name: "Title", key: 'title' },
                { name: "Author", key: 'author' },
                { name: "Accession Series", key: 'accessionSeries' },
                { name: "Accession Number", key: 'accessionNumber' },
                { name: "Role", key: 'role' },
                { name: "User ID", key: 'userId' },
                { name: "Default Academic Year", key: 'defaultAcademicYear' },
                { name: "Default Department", key: 'defaultDepartmentName' },
                { name: "Default Group", key: 'defaultGroupName' },
                { name: "Roll Number", key: 'rollNumber' },

                { name: "Issued Policy Name", key: 'issuedPolicyName' },
                { name: "Location", key: 'location' },

                { name: "Issued Date", key: 'issuedDate' },
                { name: "Due Date", key: 'dueDate' },
                { name: "Renewal Date", key: 'renewalDate' },
                { name: "Applicable Fine", key: 'applicableFine' },
                { name: "Collected Fine", key: 'collectedFine' },
                { name: "Issued by", key: 'issuedBy' }
            ],

            exportItemVisibility: [
                { name: "Issued To", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: "Accession Number", isVisible: true },
                { name: "Role", isVisible: true },
                { name: "User ID", isVisible: true },
                { name: "Default Academic Year", isVisible: true },
                { name: "Default Department", isVisible: true },
                { name: "Default Group", isVisible: true },
                { name: "Roll Number", isVisible: true },

                { name: "Issued Policy Name", isVisible: true },
                { name: "Location", isVisible: true },

                { name: "Issued Date", isVisible: true },
                { name: "Due Date", isVisible: true },
                { name: "Renewal Date", isVisible: true },
                { name: "Applicable Fine", isVisible: true },
                { name: "Collected Fine", isVisible: true },
                { name: "Issued by", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],

            //advance filter modal
            advanceFilterModal: false,
        };
    }

    componentDidMount() {
        // this.getStockVerificationIssuedResourceList(); // issued report list
        this.getDashboardStockVerification();  // report list
        this.getStockVerificationIssuedResourceList();
        // this.getFacultyList();
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF Stock Verification
    getDashboardStockVerification = async () => {
        this.setState({
            stockVerificationLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getDashboardStockVerification',
            requestData,
            '/api/library/stockVerification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getDashboardStockVerification()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            stockVerificationList: apiResult.data,
                            stockVerificationLoading: false
                        });
                    } else {
                        this.setState({
                            stockVerificationList: {},
                            stockVerificationLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        stockVerificationList: {},
                        stockVerificationLoading: false
                    });
                }
            }
        }
    }

    // issued resource report list
    getStockVerificationIssuedResourceList = async () => {
        this.setState({
            issuedResourceListLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getStockVerificationIssuedResourceList',
            requestData,
            '/api/library/stockVerification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getStockVerificationIssuedResourceList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            issuedResourceList: this.getIssuedResourceListSortedDescending(apiResult.data),
                            totalIssuedResourceListItems: apiResult.totalRecords,
                            issuedResourceListLoading: false
                        });
                    } else {
                        this.setState({
                            issuedResourceList: {},
                            totalIssuedResourceListItems: 0,
                            issuedResourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        issuedResourceList: {},
                        totalIssuedResourceListItems: 0,
                        stockVerificationLoading: false
                    });
                }
            }
        }
    }

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({
            pageIndex: 1, limit: event.target.value, searchByStockVerification: this.state.searchByStockVerification
        }, () => {
            this.getStockVerificationIssuedResourceList();
        });
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByStockVerification: this.state.searchByStockVerification }, () => {
            this.getStockVerificationIssuedResourceList();
        });
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByStockVerification: '',
            limit: "10",
            pageIndex: 1,
            issuedResourceList: {}
        }, () => {
            this.getStockVerificationIssuedResourceList();
        })
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterStockVerification = Object.entries(this.state.stockVerificationList)
            ?.filter(([id, data]) => id == this.state.searchByStockVerification.value)
            .map(([id, data]) => data.stock_verification_name)

        if (this.state.searchByStockVerification && filterStockVerification.length > 0) {
            FilterArray.push(`Stock Verification - ${filterStockVerification[0]}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllIssuedResourceReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="18" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="18" style={{ textAlign: 'center' }}>
                                Issued Resources Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="18" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="18" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="18" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Issued To</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Author</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Accession Series</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Accession Number</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Role</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>User ID</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Default Academic Year</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Default Department</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Default Group</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Roll Number</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Issued Policy Name</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Location</th>}
                        {this.state.exportItemVisibilityForRows[13].isVisible && <th>Issued Date</th>}
                        {this.state.exportItemVisibilityForRows[14].isVisible && <th>Due Date</th>}
                        {this.state.exportItemVisibilityForRows[15].isVisible && <th>Renewal Date</th>}
                        {this.state.exportItemVisibilityForRows[16].isVisible && <th>Applicable Fine</th>}
                        {this.state.exportItemVisibilityForRows[17].isVisible && <th>Collected Fine</th>}
                        {this.state.exportItemVisibilityForRows[18].isVisible && <th>Issued by</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="18">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.user_name || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.author || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.accession_series || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.user_role || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.user_id || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.defaultAcademicYear || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.defaultDepartmentName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.defaultGroupName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.rollNumber || ""}</td>}

                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.policyName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.location || ""}</td>}

                                            {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.issued_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[14].isVisible && <td>{resource?.dueDate || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[15].isVisible && <td>{resource?.renewal_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[16].isVisible && <td>{resource?.fine_amount || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[17].isVisible && <td>{resource?.collected_fine_amount || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[18].isVisible && <td>{resource?.issuedBy || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="18">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalIssuedResourceListItems } = this.state;
        const totalPages = Math.ceil(totalIssuedResourceListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });


            let requestData = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
            };


            let jsonResponse = await LibraryApiCall.makeApiCall(
                'getStockVerificationIssuedResourceList',
                requestData,
                '/api/library/stockVerification.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];
                let combinedReportData = this.getIssuedResourceListSortedDescending({ ...allReportData, ...apiResult });

                // Concatenate new data and update state
                this.setState({
                    allReportData: combinedReportData,
                    allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                    totalRecords: jsonResponse.APIResult.totalRecords,
                }, () => {

                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    getIssuedResourceSortTimestamp = (resource) => {
        const issuedDate = resource?.issued_date || resource?.issued_date_redable || "";

        if (!issuedDate) {
            return 0;
        }

        const normalizedDate = typeof issuedDate === 'string' && !issuedDate.includes('T')
            ? `${issuedDate}T00:00:00`
            : issuedDate;
        const parsedTime = new Date(normalizedDate).getTime();

        return Number.isNaN(parsedTime) ? 0 : parsedTime;
    }

    getIssuedResourceListSortedDescending = (issuedResourceList = {}) => {
        const sortedIssuedResourceEntries = Object.entries(issuedResourceList).sort((firstEntry, secondEntry) => {
            const firstDate = this.getIssuedResourceSortTimestamp(firstEntry[1]);
            const secondDate = this.getIssuedResourceSortTimestamp(secondEntry[1]);

            if (secondDate !== firstDate) {
                return secondDate - firstDate;
            }

            const firstUniqueId = Number(firstEntry[0]) || 0;
            const secondUniqueId = Number(secondEntry[0]) || 0;

            return secondUniqueId - firstUniqueId;
        });

        return Object.fromEntries(sortedIssuedResourceEntries);
    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterStockVerification = Object.entries(this.state.stockVerificationList)
            ?.filter(([id, data]) => id == this.state.searchByStockVerification.value)
            .map(([id, data]) => data.stock_verification_name)

        if (this.state.searchByStockVerification && filterStockVerification.length > 0) {
            FilterArray.push(`Stock Verification - ${filterStockVerification[0]}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Stock verification */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Stock Verification<span className='text-danger'>*</span></label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    options={Object.keys(this.state.stockVerificationList).map((key) => ({
                                                                        label: this.state.stockVerificationList[key].stock_verification_name,  // Use stock_verification_name as the label
                                                                        value: key  // Use the key (ID) as the value
                                                                    }))}
                                                                    value={this.state.searchByStockVerification}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByStockVerification: event || [],
                                                                            issuedResourceList: {} // Handle empty selection
                                                                        }, () => this.getStockVerificationIssuedResourceList());
                                                                    }}
                                                                    placeholder="Select Stock Verification Name"
                                                                    isLoading={this.state.stockVerificationLoading} // Show loading spinner while fetching
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: 400,
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: 400,
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.stockVerificationLoading ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Select "Stock Verification" to get Issued Resources Report filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        {/* <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div> */}

                                        {Object.keys(this.state.issuedResourceList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="issuedResourceReport"
                                                                    filename="IssuedResourceReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllIssuedResourceReport"   // export all functionality
                                                                    filename="ExportAllIssuedResourceReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: {} }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByStockVerification !== '') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Issued Resources Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="issuedResourceReport">
                                            <thead className="sticky-header">
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="18" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="18" style={{ textAlign: 'center' }}>
                                                        Issued Resources Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="18" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="18" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="18" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Issued To</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Author</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Accession Series</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Accession Number</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Role</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>User ID</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Default Academic Year</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Default Department</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Default Group</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Roll Number</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Issued Policy Name</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Location</th>}
                                                {this.state.exportItemVisibilityForRows[13].isVisible && <th>Issued Date</th>}
                                                {this.state.exportItemVisibilityForRows[14].isVisible && <th>Due Date</th>}
                                                {this.state.exportItemVisibilityForRows[15].isVisible && <th>Renewal Date</th>}
                                                {this.state.exportItemVisibilityForRows[16].isVisible && <th>Applicable Fine</th>}
                                                {this.state.exportItemVisibilityForRows[17].isVisible && <th>Collected Fine</th>}
                                                {this.state.exportItemVisibilityForRows[18].isVisible && <th>Issued by</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.issuedResourceListLoading ?
                                                    <tr>
                                                        <td colSpan="18">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    Object.keys(this.state.issuedResourceList).length > 0 ?
                                                        (Object.values(this.state.issuedResourceList).map((resource, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.user_name || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.title || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.author || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.accession_series || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.user_role || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.user_id || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.defaultAcademicYear || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.defaultDepartmentName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.defaultGroupName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.rollNumber || ""}</td>}

                                                                    {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.policyName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.location || ""}</td>}

                                                                    {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.issued_date_redable || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[14].isVisible && <td>{resource?.dueDate || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[15].isVisible && <td>{resource?.return_date_redable || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[16].isVisible && <td>{resource?.fine_amount || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[17].isVisible && <td>{resource?.collected_fine_amount || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[18].isVisible && <td>{resource?.issuedBy || ""}</td>}
                                                                </tr>
                                                            )
                                                        })) :
                                                        <tr>
                                                            <td colSpan="18">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.issuedResourceList).length > 0 || Object.keys(this.state.issuedResourceList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalIssuedResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalIssuedResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div >
                </div>
            </div >

        );
    }
}


export default IssuedResourceReport;
